module.exports = __webpack_public_path__ + "img/Desk Stationary A21.250ce1a3.jpg";